import React from "react";
import UserJobs from 'pages/jobactivity/UserJobs';
import { CloseIcon, Tab } from 'components';
import { useNavigate, useParams } from "react-router-dom";
import { ProfileContainer } from 'pages/addprofile/AddProfile.style';
import { PostBox } from "pages/home/Home.style";
import JobAppliedStatus from "./JobAppliedStatus";
import { useTranslation } from "react-i18next";


const TabnameRenders = (tab) => {
  if (tab === 0) {
    return 'applied-status';
  } else if (tab === 1) {
    return 'job-post';
  }
};

const JobActivity = () => {
  const navigate = useNavigate();
  const { tabname } = useParams();
  const {t} = useTranslation();
  const tablist = [
    {
      label: t('profile.JobAppliedStatus'),
      value: 0,
      content: <JobAppliedStatus />,
    },
    {
      label: t('profile.JobPost'),
      value: 1,
      content: <UserJobs />,
    },
  ];

  const TabChange = (name) => {
    navigate(`../jobs/${TabnameRenders(name)}`, { replace: true });
  };

  const TabValues = () => {
    if (tabname === 'applied-status') {
      return 0;
    } else if (tabname === 'job-post') {
      return 1;
    }
  };

  return (
    <ProfileContainer>
      <div className="profile-header">
        <CloseIcon iconType={"back"} onClick={() => navigate(-1)} />
        <div className="user-name">{t('profile.Back')}</div>
      </div>
      <PostBox className="job-applied-page-container">
        <Tab tabList={tablist} handleTabChange={(e) => TabChange(e)} callbackTabIndex={() => TabValues()} />
      </PostBox>
    </ProfileContainer>
  );
};
export default JobActivity;